import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { classes } from "../../../../utils/classes";
import { typeSafeObjectEntries } from "../../../../utils/helpers";
import useSettings from "../../hooks/useSettings";
import Card from "../../../../components/Card";
import Select from "../Select";
import Toggle from "../Toggle";
export default function Settings(props) {
    const { className } = props;
    const settings = useSettings();
    return (_jsx(Card, { className: classes("absolute top-0 left-0 mx-4 my-6", className), title: "Extension Settings", children: _jsx("ul", { className: "flex flex-col gap-4", children: typeSafeObjectEntries(settings).map(([key, setting]) => {
                if (!setting.configurable)
                    return null;
                return (_jsxs("li", { className: "flex items-center", children: [setting.type === "boolean" && (_jsx(Toggle, { label: setting.title, value: setting.value, onChange: setting.change })), setting.type === "select" && (_jsx(Select, { label: setting.title, value: setting.value, options: setting.options, onChange: setting.change }))] }, key));
            }) }) }));
}
